import React, { useState, useEffect } from 'react';
import './CouponUsed.css';
import { useNavigate,useLocation } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';
import {set} from 'date-fns';

function CouponUsed() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
const [mode, setMode] = useState('QR'); // or 'BARCODE'
const [userData, setUserData] = useState(null);
const [showPopup, setShowPopup] = useState(false);
const [showErrorPopup, setShowErrorPopup] = useState(false);
const [errorMessage, setErrorMessage] = useState('');
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const couponId = queryParams.get("coupon_id");
const userCouponId = queryParams.get("user_coupon_id");
const [isLoading, setIsLoading] = useState(false);
const [showMenu, setShowMenu] = useState(false);


const [coupon, setCoupon] = useState(null);

const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);

useEffect(() => {
  const fetchCoupon = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/coupon/?coupon_id=${couponId}&page=1&limit=1000`);
      const result = await res.json();
      if (result?.content?.data?.length > 0) {
        setCoupon(result.content.data[0]);
      }
    } catch (error) {
      console.error("Failed to fetch coupon:", error);
    }
  };

  if (couponId) {
    fetchCoupon();
  }
}, [couponId]);

useEffect(() => {
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
      setIsLoading(false);
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);



  const handleUseCoupon = async () => {
    if (!coupon) {
      setErrorMessage(t.coupon_description.error);
      setShowErrorPopup(true);
      return;
    }

    setIsLoading(true);

    try {
      // 1) Mark coupon as used in your backend
      const useRes = await fetch(
        `${CONFIG.API_BASE_URL}/coupon/use_coupon?user_coupon_id=${userCouponId}`,
        {
          method: 'POST',
        }
      );

      const useResult = await useRes.json();
      if (!useRes.ok) {
        setErrorMessage(t.coupon_description.full_coupon);
        setShowErrorPopup(true);
        setIsLoading(false);
        return;
      }

      // 2) Build the WooCommerce payload
      //    code === "UF{couponId}CID{userCouponId},{discount_value}"
      const wcCode = `UF${userCouponId}CID${couponId},${coupon.discount_value}`;
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const wcPayload = {
        code: wcCode,
        type: 'fixed_cart',
        amount: coupon.discount_value.toString(),
        minimum_amount: '0',
        description: coupon.name,
        customer_emails: [],
        usage_limit: 1,
        date_expires: tomorrow.toISOString(),
        exclude_sale_items: false
      };

      // 3) POST to WooCommerce create_coupon endpoint
      const wcRes = await fetch(
        `${CONFIG.API_BASE_URL}/woocommerce/create_coupon`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', accept: 'application/json' },
          body: JSON.stringify(wcPayload),
        }
      );

      const wcResult = await wcRes.json();
      if (!wcRes.ok) {
        console.error("WooCommerce create_coupon failed:", wcResult);
        setShowErrorPopup(true);
        setErrorMessage(t.coupon_description.error);
        setIsLoading(false);
        return;
      }

      // 4) If both succeed, navigate to countdown
      navigate(`/countdown?coupon_id=${couponId}&user_coupon_id=${userCouponId}`);
    } catch (err) {
      console.error('Error in handleUseCoupon:', err);
      alert('Something went wrong while using the coupon');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>
      

 {isLoading && (
  <div className="full-screen-spinner">
    <div className="spinner" />
  </div>
)}


      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>


    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.coupon_description.coupon_description}</span>
</div>

<div className="coupon-detail-container">
    <div className="coupon-image-wrapper-main">
  <img
    src={coupon?.image_url || "/assets/default-coupon.png"}
    alt={coupon?.name || "coupon"}
    className="coupon-image-main"
  />
</div>

  <div className="coupon-tag-box-used">
 

      <span style={{ fontSize: '12px', color: '#999',  }}>from batch expiring on {coupon?.expired_at ? new Date(coupon.expired_at).toLocaleDateString('en-GB') : ''}</span>

  </div>

  <h3 className="coupon-title-main">
      {
language === 'EN' ? coupon?.name_en || '' : coupon?.name || ''
      }</h3>
<br/>
  <div className="coupon-description">
    {/* <h4 className="coupon-subtitle">Lorem ipsum</h4> */}

      {language === 'EN' ? <> { (coupon?.description_en || '').split('\n').map((line, i) => (
            <p key={i} className="coupon-text">
            {line}
            </p>
          )) }</> : <> { (coupon?.description || '').split('\n').map((line, i) => (
            <p key={i} className="coupon-text">
            {line}
            </p>
          )) }</>}

   
  </div>

    <button className="redeem-button-full" onClick={() => setShowPopup(true)}>{t.coupon_description.redeem}</button>
</div>

     {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3 style={{color: '#037887', fontWeight: 'bold'}}>{t.coupon_description.confirm_redeem}</h3>
            <p style={{ color: '#7975E9', fontWeight: 'bold' }}>{coupon?.name || ''}</p>
      
            <div className="popup-buttons">
              <button className="cancel-btn" onClick={() => setShowPopup(false)}>Cancel</button>
              <button className="confirm-btn" onClick={handleUseCoupon}>Confirm</button>
            </div>
          </div>
        </div>
      )}

       {showErrorPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3 style={{color: '#037887', fontWeight: 'bold'}}>{errorMessage}</h3>
            <p style={{ color: '#7975E9', fontWeight: 'bold' }}>{coupon?.name || ''}</p>
      
            <div className="popup-buttons">
              <button className="cancel-btn" onClick={() => setShowErrorPopup(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}



    </div>
  );
}

export default CouponUsed;
